/**
 * Store 도메인 Query Hook Wrapper
 *
 * Factory를 사용하여 Store 관련 데이터를 조회합니다.
 */

import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {STORE_QUERY_KEY_MAP} from '../api/store/constant';
import {storeFactory} from '../factory/storeFactory';

// ============================================
// useReceiptInfoResultQuery
// ============================================

export function useReceiptInfoResultQuery(
  ...args: Parameters<typeof storeFactory.receiptInfoResult>
) {
  return useQuery(storeFactory.receiptInfoResult(...args));
}

useReceiptInfoResultQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.receiptInfoResult>
) => [...STORE_QUERY_KEY_MAP.receiptInfoResult(...args)];

// ============================================
// useInfiniteBestCommentListQuery
// ============================================

export function useInfiniteBestCommentListQuery(
  ...args: Parameters<typeof storeFactory.infiniteBestCommentList>
) {
  return useInfiniteQuery(storeFactory.infiniteBestCommentList(...args));
}

useInfiniteBestCommentListQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteBestCommentList>
) => [...STORE_QUERY_KEY_MAP.infiniteBestCommentList(...args)];

// ============================================
// useInfiniteBuyCashHistoryQuery
// ============================================

export function useInfiniteBuyCashHistoryQuery(
  ...args: Parameters<typeof storeFactory.infiniteBuyCashHistory>
) {
  return useInfiniteQuery(storeFactory.infiniteBuyCashHistory(...args));
}

useInfiniteBuyCashHistoryQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteBuyCashHistory>
) => [...STORE_QUERY_KEY_MAP.infiniteBuyCashHistory(...args)];

// ============================================
// useInfiniteBuyTicketHistoryQuery
// ============================================

export function useInfiniteBuyTicketHistoryQuery(
  ...args: Parameters<typeof storeFactory.infiniteBuyTicketHistory>
) {
  return useInfiniteQuery(storeFactory.infiniteBuyTicketHistory(...args));
}

useInfiniteBuyTicketHistoryQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteBuyTicketHistory>
) => [...STORE_QUERY_KEY_MAP.infiniteBuyTicketHistory(...args)];

// ============================================
// useUserCashQuery
// ============================================

export function useUserCashQuery(
  ...args: Parameters<typeof storeFactory.userCash>
) {
  return useQuery(storeFactory.userCash(...args));
}

useUserCashQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.userCash>
) => [...STORE_QUERY_KEY_MAP.userCash(...args)];

// ============================================
// useWelcomeQuery
// ============================================

export function useWelcomeQuery(
  ...args: Parameters<typeof storeFactory.welcome>
) {
  return useQuery(storeFactory.welcome(...args));
}

useWelcomeQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.welcome>
) => [...STORE_QUERY_KEY_MAP.welcome(...args)];

// ============================================
// useTodayGiftListQuery
// ============================================

export function useTodayGiftListQuery(
  ...args: Parameters<typeof storeFactory.todayGiftList>
) {
  return useQuery(storeFactory.todayGiftList(...args));
}

useTodayGiftListQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.todayGiftList>
) => [...STORE_QUERY_KEY_MAP.todayGiftList(...args)];

// ============================================
// useBlockUserListQuery
// ============================================

export function useBlockUserListQuery(
  ...args: Parameters<typeof storeFactory.blockUserList>
) {
  return useQuery(storeFactory.blockUserList(...args));
}

useBlockUserListQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.blockUserList>
) => [...STORE_QUERY_KEY_MAP.blockUserList(...args)];

// ============================================
// useCommentItemQuery
// ============================================

export function useCommentItemQuery(
  ...args: Parameters<typeof storeFactory.commentItem>
) {
  return useQuery(storeFactory.commentItem(...args));
}

useCommentItemQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.commentItem>
) => [...STORE_QUERY_KEY_MAP.commentItem(...args)];

// ============================================
// useInfiniteCommentListQuery
// ============================================

export function useInfiniteCommentListQuery(
  ...args: Parameters<typeof storeFactory.infiniteCommentList>
) {
  return useInfiniteQuery(storeFactory.infiniteCommentList(...args));
}

useInfiniteCommentListQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteCommentList>
) => [...STORE_QUERY_KEY_MAP.infiniteCommentList(...args)];

// ============================================
// useContentTicketDetailQuery
// ============================================

export function useContentTicketDetailQuery(
  ...args: Parameters<typeof storeFactory.contentTicketDetail>
) {
  return useQuery(storeFactory.contentTicketDetail(...args));
}

useContentTicketDetailQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.contentTicketDetail>
) => [...STORE_QUERY_KEY_MAP.contentTicketDetail(...args)];

// ============================================
// useSinglePreviewQuery
// ============================================

export function useSinglePreviewQuery(
  ...args: Parameters<typeof storeFactory.singlePreview>
) {
  return useQuery(storeFactory.singlePreview(...args));
}

useSinglePreviewQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.singlePreview>
) => [...STORE_QUERY_KEY_MAP.singlePreview(...args)];

// ============================================
// useInfiniteContentTicketInfoQuery
// ============================================

export function useInfiniteContentTicketInfoQuery(
  ...args: Parameters<typeof storeFactory.infiniteContentTicketInfo>
) {
  return useInfiniteQuery(storeFactory.infiniteContentTicketInfo(...args));
}

useInfiniteContentTicketInfoQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteContentTicketInfo>
) => [...STORE_QUERY_KEY_MAP.infiniteContentTicketInfo(...args)];

// ============================================
// useInfiniteMyCommentListQuery
// ============================================

export function useInfiniteMyCommentListQuery(
  ...args: Parameters<typeof storeFactory.infiniteMyCommentList>
) {
  return useInfiniteQuery(storeFactory.infiniteMyCommentList(...args));
}

useInfiniteMyCommentListQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteMyCommentList>
) => [...STORE_QUERY_KEY_MAP.infiniteMyCommentList(...args)];

// ============================================
// useInfiniteReplyCommentListQuery
// ============================================

export function useInfiniteReplyCommentListQuery(
  ...args: Parameters<typeof storeFactory.infiniteReplyCommentList>
) {
  return useInfiniteQuery(storeFactory.infiniteReplyCommentList(...args));
}

useInfiniteReplyCommentListQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteReplyCommentList>
) => [...STORE_QUERY_KEY_MAP.infiniteReplyCommentList(...args)];

// ============================================
// useInfiniteUseCashHistoryQuery
// ============================================

export function useInfiniteUseCashHistoryQuery(
  ...args: Parameters<typeof storeFactory.infiniteUseCashHistory>
) {
  return useInfiniteQuery(storeFactory.infiniteUseCashHistory(...args));
}

useInfiniteUseCashHistoryQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteUseCashHistory>
) => [...STORE_QUERY_KEY_MAP.infiniteUseCashHistory(...args)];

// ============================================
// useInfiniteUseTicketHistoryQuery
// ============================================

export function useInfiniteUseTicketHistoryQuery(
  ...args: Parameters<typeof storeFactory.infiniteUseTicketHistory>
) {
  return useInfiniteQuery(storeFactory.infiniteUseTicketHistory(...args));
}

useInfiniteUseTicketHistoryQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.infiniteUseTicketHistory>
) => [...STORE_QUERY_KEY_MAP.infiniteUseTicketHistory(...args)];

// ============================================
// useMyNewsQuery
// ============================================

export function useMyNewsQuery(
  ...args: Parameters<typeof storeFactory.myNews>
) {
  return useQuery(storeFactory.myNews(...args));
}

useMyNewsQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.myNews>
) => [...STORE_QUERY_KEY_MAP.myNews(...args)];

// ============================================
// useMyRatingQuery
// ============================================

export function useMyRatingQuery(
  ...args: Parameters<typeof storeFactory.myRating>
) {
  return useQuery(storeFactory.myRating(...args));
}

useMyRatingQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.myRating>
) => [...STORE_QUERY_KEY_MAP.myRating(...args)];

// ============================================
// usePopupQuery
// ============================================

export function usePopupQuery(...args: Parameters<typeof storeFactory.popup>) {
  return useQuery(storeFactory.popup(...args));
}

usePopupQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.popup>
) => [...STORE_QUERY_KEY_MAP.popup(...args)];

// ============================================
// useReceiptInfoQuery
// ============================================

export function useReceiptInfoQuery(
  ...args: Parameters<typeof storeFactory.receiptInfo>
) {
  return useQuery(storeFactory.receiptInfo(...args));
}

useReceiptInfoQuery.getKey = (
  ...args: Parameters<typeof STORE_QUERY_KEY_MAP.receiptInfo>
) => [...STORE_QUERY_KEY_MAP.receiptInfo(...args)];
